import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { Subscription } from "rxjs";
import { TranslationService } from "./translation.service";

@Pipe({
  name: "t",
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;

  constructor(
    private translationService: TranslationService,
    private cdr: ChangeDetectorRef,
  ) {
    this.subscription = this.translationService.language$.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  transform(key: unknown): string {
    if (key === null || key === undefined) {
      return this.translationService.instant(undefined);
    }

    if (typeof key === "string") {
      return this.translationService.instant(key);
    }

    return this.translationService.instant(String(key));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
